import { render, staticRenderFns } from "./TableCmpOther.vue?vue&type=template&id=961cceae&scoped=true"
import script from "./TableCmpOther.vue?vue&type=script&lang=js"
export * from "./TableCmpOther.vue?vue&type=script&lang=js"
import style0 from "./TableCmpOther.vue?vue&type=style&index=0&id=961cceae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961cceae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('961cceae')) {
      api.createRecord('961cceae', component.options)
    } else {
      api.reload('961cceae', component.options)
    }
    module.hot.accept("./TableCmpOther.vue?vue&type=template&id=961cceae&scoped=true", function () {
      api.rerender('961cceae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/PostalDelivery/TableCmpOther.vue"
export default component.exports